export default "__VITE_ASSET__DsRGVxUU__"